import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTagModule } from 'ng-zorro-antd/tag';

@Component({
  selector: 'app-tag',
  template: `
    <nz-tag
      class="tag"
      [nzMode]="'closeable'"
      (nzOnClose)="tagClosed.emit()"
    >
      <i
        *ngIf="icon"
        nz-icon
        [nzType]="icon"
      ></i>
      <span class="tag__content">{{ title }}</span>
    </nz-tag>
  `,
  styleUrls: ['./tag.component.less'],
  imports: [NzTagModule, NzIconModule, NgIf],
  standalone: true
})
export class TagComponent {
  @Input() public title?: string;
  @Input() public icon?: string;
  @Output() public tagClosed = new EventEmitter<void>();
}
